import { api, refreshOnce } from "@/lib/api"
import { authStore } from "@/lib/auth"
import { queryClient } from "@/lib/query"
import type { TokenResponse } from "@/lib/types"

let booted: Promise<void> | null = null

/** App start: try the refresh cookie once (module-level single flight survives StrictMode). */
export function bootstrapSession(): Promise<void> {
  booted ??= refreshOnce().then((ok) => {
    if (!ok) authStore.signOut()
  })
  return booted
}

export async function signIn(email: string, password: string, captcha: string): Promise<TokenResponse> {
  const res = await api<TokenResponse>("/auth/login", {
    method: "POST",
    body: { email, password, captcha },
  })
  authStore.signIn(res.access_token, res.user)
  return res
}

export async function signOut(): Promise<void> {
  try {
    await api<void>("/auth/logout", { method: "POST", headers: { "X-Requested-With": "fetch" } })
  } catch {
    // Signing out locally is what matters; the cookie may already be gone.
  }
  authStore.signOut()
  queryClient.clear()
}

export function homeFor(role: "owner" | "coordinator"): string {
  return role === "coordinator" ? "/portal" : "/"
}
